module.exports = __webpack_public_path__ + "img/q3.e848bc99.png";